import { motion } from "framer-motion";
import { Mail, ArrowRight } from "lucide-react";
import PublicLayout from "@/components/PublicLayout";
import { supportEmail } from "@/lib/companyBrand";

const ContactPage = () => (
  <PublicLayout>
    <main className="relative z-10 px-4 md:px-8 pt-12 md:pt-20 pb-20 md:pb-32 max-w-2xl mx-auto safe-area-padding">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="text-center mb-12"
      >
        <h1
          className="text-3xl md:text-5xl font-light tracking-tight mb-4"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Partner with us
        </h1>
        <p className="text-base md:text-lg text-zinc-400 max-w-lg mx-auto">
          We're building the future of music education technology and we'd love to collaborate.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="space-y-6"
      >
        <div className="bg-zinc-900/50 border border-white/5 rounded-2xl p-6 md:p-8">
          <p className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-4">Partnership Opportunities</p>
          <div className="space-y-4 text-sm text-zinc-400 leading-relaxed">
            <p>
              Whether you're a music school looking to integrate Hans into your curriculum, a conservatory
              exploring AI-assisted pedagogy, or a technology company with complementary tools — we're
              open to partnership discussions.
            </p>
            <p>We're especially interested in collaborating with:</p>
            <ul className="space-y-2 ml-1">
              <li className="flex items-start gap-2.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#f4cf08]/60 shrink-0 mt-1.5" />
                <span>Music schools and conservatories</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#f4cf08]/60 shrink-0 mt-1.5" />
                <span>Music education organizations and nonprofits</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#f4cf08]/60 shrink-0 mt-1.5" />
                <span>EdTech companies and learning platforms</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#f4cf08]/60 shrink-0 mt-1.5" />
                <span>Music instrument retailers and manufacturers</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-zinc-900/50 border border-white/5 rounded-2xl p-6 md:p-8 text-center">
          <Mail className="w-6 h-6 text-zinc-500 mx-auto mb-3" strokeWidth={1.5} />
          <p className="text-sm text-zinc-400 mb-4">
            Reach out to start a conversation about how we can work together.
          </p>
          <a
            href={`mailto:${supportEmail()}?subject=Partnership%20Inquiry`}
            className="inline-flex items-center gap-2 bg-[#f4cf08] text-black font-medium rounded-full px-8 py-3 text-sm
                       hover:scale-105 active:scale-95 transition-transform shadow-[0_0_40px_rgba(244,207,8,0.25)]"
          >
            <Mail className="w-4 h-4" /> Contact Us <ArrowRight className="w-4 h-4" />
          </a>
          <p className={"text-xs text-zinc-600 mt-3" /* brand-lint-ignore: legacy page idiom */}>{supportEmail()}</p>
        </div>
      </motion.div>
    </main>
  </PublicLayout>
);

export default ContactPage;
